import { useSelector } from "react-redux";
import FilterSelection from "../FilterSelection";
import styles from "./FilterGroup.module.scss";

function FilterGroup({ group, type }) {
  const { activeFilterView } = useSelector((state) => state.view);
  return (
    <div className={styles.filterGroup}>
      <h2 className={styles.filterGroupHeader}>{type}</h2>
      {group.map((item) => (
        <FilterSelection
          key={item.id}
          name={item.name}
          id={item.id}
          type={type}
          activeFilterView={activeFilterView}
          label={item.name}
        >
          {item.description}
        </FilterSelection>
      ))}
    </div>
  );
}

export default FilterGroup;
